export default __webpack_public_path__ + "static/media/main-arrows.81771195.svg";